export default __webpack_public_path__ + "static/seb-6841bb9fedf6c9eb87ebf3786d7aefe9.jpg";